import { CSSObject, Theme } from '@core-ui/react-stitch';

const getMenuStyles =
  (isBRRedesignEnabled: boolean) =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...(isBRRedesignEnabled
      ? {
          backgroundColor: theme.color.inverse.b1,
          boxShadow: 'none',
          width: '6.25rem',
          '&[aria-activedescendant]': {
            border: `0.063rem solid ${theme.color.b2}`,
          },
        }
      : {}),
  });

export default getMenuStyles;